import React from 'react'
import OneLineContent from 'containers/RenderStroyComponent/OneLineContent'

export type ClickWordHandler = (event: any, wordObj: any, sentence: any, key: string) => void

interface ZhWordsProps {
  /** Segmented words, from the backend (question, passage, answers) or segmentText. */
  words: Array<{ word: string; pinyin?: string; english?: string; plain?: boolean }>
  iterator: string
  story: any
  activeIndex: string
  onClickWord: ClickWordHandler
  fontSize?: string
  pinyinSize?: string
  showPinYin?: boolean
  bold?: boolean
}

/**
 * Chinese text where every word opens the dictionary, through the same
 * OneLineContent/Word plumbing as the story and question pages. Plain tokens
 * (punctuation, Latin text) render as they are.
 */
const ZhWords: React.FC<ZhWordsProps> = ({
  words,
  iterator,
  story,
  activeIndex,
  onClickWord,
  fontSize = '20px',
  pinyinSize,
  showPinYin = false,
  bold = false,
}) => {
  const tappable = words.filter((w) => !w.plain)
  const sizes = { storyContent: fontSize, pinyinValue: pinyinSize }
  return (
    <span className={`word_wrapper ws-zh${bold ? ' ws-zh-bold' : ''}`}>
      {words.map((token, index) =>
        token.plain ? (
          <span key={index} className='ws-plain' style={{ fontSize }}>
            {token.word}
          </span>
        ) : (
          <OneLineContent
            key={index}
            WIndex={index}
            iterator={iterator}
            wordObj={token}
            contentDetail={tappable}
            story={story}
            showPinYin={showPinYin}
            activeIndex={activeIndex}
            handleClickWord={onClickWord}
            chineseWordFontSize={sizes}
          />
        ),
      )}
    </span>
  )
}

export default ZhWords
